import { NotificationPosition } from '@anm/components/NotificationBlock';
import Button from '@anm/components/buttons/Button/Button';
import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import getFromCdn from '@anm/helpers/getFromCdn';
import styled, { css } from 'styled-components';

type WrapperProps = {
  position: NotificationPosition;
  isPending: boolean;
};

const appearAnimation = css`
  animation-name: appear;
  animation-duration: 0.3s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in;
  @keyframes appear {
    0% {
      opacity: 0;
      margin-top: 10px;
    }
    60% {
      margin-top: 10px;
    }
    100% {
      opacity: 1;
      margin-top: 0;
    }
  }
`;

export const Wrapper = styled.div<WrapperProps>`
  position: fixed;
  z-index: 7;
  min-width: 285px;
  background: #fff;
  padding: ${({ isPending }) => (isPending ? '20px' : '20px 22px 20px 28px')};
  box-shadow: 0px 5px 20px rgba(1, 83, 130, 0.2);
  border-radius: 10px;
  ${appearAnimation};

  ${({ position }) => css`
    top: ${position.top};
    left: ${position.left};
    transform: translate(calc(-${position?.translateX || '0px'} / 2 - 50%), 20px);
  `}

  p {
    font-size: 12px;
    margin: 0;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const DiscardButton = styled(Button)`
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #919eaa;
  font-weight: bold;
  transition: 0.2s;
  margin-right: 20px;

  &:hover {
    color: #292a2b;
  }
`;
export const SaveButton = styled(ButtonLoader)`
  padding: 0 10px;
  min-width: 150px;
`;

export const SavingSpinner = styled.div`
  width: 225px;
  min-height: 40px;
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 22px;
  color: #292a2b;
  padding-left: 77px;

  &:before {
    display: block;
    content: '';
    background: url(${getFromCdn('images/icons/white_spinner.svg')}) no-repeat center / 14px 14px, #4eda9d;

    width: 30px;
    height: 30px;
    margin-right: 10px;
    border-radius: 50%;
  }
`;

export const UpgradeDescription = styled.div`
  margin-top: 16px;
  font-family: Inter;
  font-size: 14px;
  line-height: 22px;
  color: #919eaa;
  display: flex;
  max-width: 235px;
  justify-content: center;

  &:before {
    display: block;
    content: '';
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    margin-right: 10px;
    background: url(${getFromCdn('images/icons/crown.svg')}) no-repeat center / cover;
  }
`;
